import React from 'react';

export function Divider() {
  return <div className="app-divider" />;
}
